<template>
  <v-content fluid fill-height>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex style="margin-top: -100px;" xs12 sm8 md6>
          <v-card class="elevation-12">
            <v-toolbar dark color="blue lighten-1">
              <v-toolbar-title>Login form</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field color="red lighten-1" v-model="email" prepend-icon="person" name="login" label="Login" type="text"></v-text-field>
                <v-text-field color="red lighten-1" v-model="password" id="password" prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
              </v-form>
              <div class="font-weight-bold text-md-center msg">{{msg}}</div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="login()" color="blue lighten-1`" :loading="loading">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
    import axios from 'axios';

    export default {
        data: () => ({
            msg         : '',
            email       : '',
            password    : ''
        }),
        props: ['loading'],

        methods: {
            login: function (event) {
                this.$emit('update:loading', true);
                axios.post(this.$server_api_url + `/api/v1/user/login`, {
                    email : this.email,
                    password : this.password,
                })
                    .then(response => {
                        if(response.data.err) {
                            this.msg = response.data.errdesc;
                        }
                        else {
                          location.href = this.$server_url + '/app/home';
                          // log('response.data.entity', response.data.entity)
                          // this.$user = response.data.entity;
                          // this.$emit('update:$user', response.data.entity);
                          // this.$router.replace('home')
                        }
                    })
                    .catch(e => {
                        this.msg = e
                    })
                    .finally(()=>{
                      this.$emit('update:loading', false)
                    })
            }
        },
        beforeRouteLeave(to, from, next) {
            this.$emit('update:loading', true);
            next();
        },
        created() {
          axios.get(this.$server_api_url + `/api/v1/user/curr`)
                  .then(response => {
                    if(!(+response.data.err)) {
                      // log('11111111111111');
                      location.href = location.origin + '/app/'
                    }
                  })
                  .finally(()=>{
                    this.$emit('update:loading', false);
                  });
        }
    }
</script>

<style>
  .msg {
    color: red
  }
</style>